/* -
---- FETCH
- */

const fetchParams = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
}

export function getFetchUrl(pathname) { 
    
    const location = window.location
    const hostname = location.hostname
    const protocol = location.protocol

    let url = `${protocol}//${hostname}`

    if(hostname === 'incoherences.org'){
        url += '/server/'
    } else if (hostname === 'localhost' || hostname.includes('192.168.1.')){
        url += ':5000/'
    } else{
        throw new Error('Wrong origin...')
    }

    return `${url}${pathname}`
}
export function getFetchParams() { return fetchParams }

export const setUserStorage = async (checkServerUp, noUser, setUser, tz, a, u, i, ii, s) => {
    const serverResponse = await fetch(getFetchUrl('users'), {
        ...getFetchParams(),
        body: JSON.stringify({
            utcOffset: tz,
            a,
            u,
            i,
            ii,
            s,
        }),
    })
        .catch(error => {
            checkServerUp(error, noUser)

            return {
                success: false,
                message: 'Something went wrong...',
            }
        })

    if (serverResponse && serverResponse.ok) {
        const response = await serverResponse.json()
        const remainingSeconds = response.data?.remainingSeconds ?? 0

        if(response.data){
            localStorage.setItem('user', JSON.stringify(response.data))
        }
        else{
            localStorage.removeItem('user')
        }
        localStorage.setItem('remainingSeconds', remainingSeconds)
        setUser(JSON.stringify(response.data))

        return response
    } else {
        window.location.patName = 'maintenance'
    }
}

export const getGeneratedIcons = async (isLogin = false, u = null) => {
    const serverResponse = await fetch(getFetchUrl('pgen'), {
        ...getFetchParams(),
        body: JSON.stringify({ isLogin, u }),
    })

    if(serverResponse && serverResponse.ok){
        const result = await serverResponse.json()

        return result
    } else {
        window.location.patName = 'maintenance'

        return 
    }
}

export const checkSessionToken = async (storage, setUser, checkServerUp, noUser) => {
    const sessionToken = storage.sessionToken

    const serverResponse = await fetch(getFetchUrl('users'), {
        ...getFetchParams(),
        body: JSON.stringify({
            a: 'checkSessionToken',
            s: sessionToken,
        }),
    })
        .catch(error => {
            checkServerUp(error, noUser)

            return {
                success: false,
                message: 'Something went wrong...',
            }
        })

    if (serverResponse && serverResponse.ok) {
        const response = await serverResponse.json()
        if (response.data) {
            localStorage.setItem('user', JSON.stringify(response.data))
            setUser(response.data)
        }
    } else {
        window.location.patName = 'maintenance'

        return 
    }
}
